export default "__VITE_ASSET__CKgoxVx5__"